import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import { useIdleTimer } from 'react-idle-timer';

import Spinner from "./components/UI/Backdrops/Spinner/Spinner";
import Layout from "./components/UI/Layout";
import AdminPage from "./containers/Admin/AdminPage";
import Dashborad from "./containers/Dashborad/Dashborad";
import EditProfile from "./containers/Edit Profile/EditProfile";
import Login from "./containers/Login/Login";
import ResetPassword from "./containers/Login/ResetPassword";
import ParkersPage from "./containers/Parkers/ParkersPage";
import { CLIENT_ROUTES, ROLES_NAMES, LOCAL_STORAGE_ITEMS_KEYS } from "./enums/Enums";
import RequireAuth from "./hoc/RequireAuth";
import { userActions } from "./redux/reducers/UserReducer";
import { reactPlugin } from "./services/Azure/ApplicationInsightsActions";
import * as actionsService from "./services/ActionsService/ActionsService";
import store from "./redux/Store";
import SignUpNewGmtUser from "./containers/Login/SignUpNewGmtUser";
import BillingPage from "./containers/Billing/BillingPage";
import { commonActions } from "../src/redux/reducers/CommonReducer";
import { getFilteredScopesList } from "./utils/UsersUtils";
import { showErrorMessage } from "./utils/MessagesUtils";
import { handleLogout } from "./utils/MenuUtils";
import useWindowDimensions from './hooks/useWindowDimensions';
import * as encryptedLocalStorageActions from "./managers/Storage/EncryptedLocalStorageActions";
import MessagingPage from "./containers/Messaging/MessagingPage";
import LegalPage from "./containers/Legal/LegalPage";
//import WorkspacePage from "./containers/Workspace/WorkspacePage";
import AllocationsPage from "./containers/Allocations/AllocationsPage";
import ValidationsPage from "./containers/Validations/ValidationsPage";
import HistoryPage from "./containers/History/HistoryPage";
import { TIMEOUTS } from "./config/Config";
import UnsubscribeUser from "./containers/Login/UnsubscribeUser";


function App() {
  const { height, width } = useWindowDimensions();
  const logoutRoutes = [CLIENT_ROUTES.RESET_PASSWORD, CLIENT_ROUTES.SIGNUP];
  const isLogoutRequired = logoutRoutes.map(route => window.location.pathname.startsWith(route)).includes(true);

  let gmtUser = useSelector((state) => state.user.gmtUser);
  let isChargeAccount = gmtUser?.userIdentity?.userScopes?.some(us => us?.role?.name === ROLES_NAMES.CHARGE_ACCOUNT);
  let initialRoute = isChargeAccount ? CLIENT_ROUTES.VALIDATIONS : CLIENT_ROUTES.PARKERS;
  const isUserLoggedInState = useSelector((state) => {
    return state.user.isUserLoggedIn;
  });

  useIdleTimer({
    timeout: TIMEOUTS.SESSION_LOGOUT_TIME, onIdle: () => {
      handleLogout();
      gmtUser = {};
    }
  });

  useEffect(() => {
    // if user reached Reset Password or Signup page and a saved user on cache exists, logout
    if (isLogoutRequired) {
      handleLogout();
      gmtUser = {};
    }

    if (gmtUser?.utronUser && actionsService) {
      encryptedLocalStorageActions.getObjectStorageItem(LOCAL_STORAGE_ITEMS_KEYS.SELECTED_SCOPE_PERSIST)
        .then((persistSelectedScopeRes) => {
          var selectedScopeId = persistSelectedScopeRes?.id ? persistSelectedScopeRes?.id : "";

          actionsService
            ?.getInitialState(gmtUser?.utronUser?.identityId, selectedScopeId, true, false)
            .then((initialStateResponse) => {
              if (initialStateResponse.data.isSuccess) {
                store.dispatch(
                  userActions.setInitialState(initialStateResponse.data.entity)
                );
                // actionsService.getUserSites(false).then((response) => {
                //   store.dispatch(userActions.setSites(response.data.entity));
                // });
                // actionsService.getUserScopes(gmtUser?.utronUser?.identityId, true, false).then((response) => { 
                //encryptedLocalStorageActions.getObjectStorageItem(LOCAL_STORAGE_ITEMS_KEYS.SELECTED_SCOPE_PERSIST)
                //.then(persistSelectedScopeRes => {
                if (persistSelectedScopeRes && persistSelectedScopeRes !== null) {
                  store.dispatch(userActions.setSelectedScope(persistSelectedScopeRes));
                } else {
                  //store.dispatch(userActions.setSelectedScope(initialStateResponse.data.entity.scopes[0]));
                  let filteredScopesList = getFilteredScopesList(initialStateResponse.data.entity.scopes, initialStateResponse.data.entity.roles, gmtUser.utronUser.identityId);
                  store.dispatch(userActions.setSelectedScope(filteredScopesList[0]));
                }
                // })
                // })
                // .catch((error) => {
                //   console.log(error);
                //   //showErrorMessage(initialStateResponse.data?.error);
                //   //reject(error);
                // })             
              }
              else {
                showErrorMessage(initialStateResponse.data?.error);
                store.dispatch(commonActions.setIsShowLoadingSpinner(false));
                actionsService.isExistUser(gmtUser?.utronUser?.identityId).then(response => {
                  if (response.data.isSuccess) {
                    if (!response.data.entity) {
                      store.dispatch(userActions.logout());
                    }
                  }
                })
              }
            })
            .catch((error) => {
              console.log(error);
            });

            // get all scopes
            actionsService.getAllScopes(true, false)
            .then((response) => {
              if (response.data.isSuccess) {
                store.dispatch(userActions.setAllScopes(response.data.entity));
              }
              else {
                showErrorMessage(response.data?.error);
                store.dispatch(commonActions.setIsShowLoadingSpinner(false));
              }
            })
            .catch((error) => {
              console.log(error);
            });

            // on refresh get the most updated data for the logged in user
            actionsService.getLoggedInUser(gmtUser?.userIdentity?.id, true, false)
            .then(response => {
              if (response.data.isSuccess) {
                store.dispatch(userActions.updateGmtUser(response.data));
              }
              else {
                showErrorMessage(response.data?.error);
                store.dispatch(commonActions.setIsShowLoadingSpinner(false));
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        })
    }
  }, [gmtUser?.accessToken]);

  return (
    <div style={{ height: height, width: width, overflow: "hidden" }}>
      <Spinner></Spinner>
      <Routes>
        <Route
          path={CLIENT_ROUTES.LOGIN}
          element={
            isUserLoggedInState ? (
              <Navigate replace to={initialRoute} />
            ) : (
              <Login />
            )
          }
        />
        <Route
          path={CLIENT_ROUTES.RESET_PASSWORD}
          element={<ResetPassword />}
        />
        <Route
          path={CLIENT_ROUTES.UNSUBSCRIBE}
          element={<UnsubscribeUser windowDimensions={{height, width}} />}
        />
        <Route
          path={CLIENT_ROUTES.SIGNUP}
          element={<SignUpNewGmtUser />}
        />
        <Route
          path={CLIENT_ROUTES.PARKERS}
          element={
            <RequireAuth>
              <Layout>
                <ParkersPage />
              </Layout>
            </RequireAuth>
          }
        />
        <Route
          path={CLIENT_ROUTES.BILLING}
          element={
            <RequireAuth>
              <Layout>
                <BillingPage />
              </Layout>
            </RequireAuth>
          }
        />
        <Route
          path={CLIENT_ROUTES.LEGAL}
          element={
            <RequireAuth>
              <Layout>
                <LegalPage />
              </Layout>
            </RequireAuth>
          }
        />
        <Route
          path={CLIENT_ROUTES.EDIT_PROFILE}
          element={
            <RequireAuth>
              <Layout>
                <EditProfile />
              </Layout>
            </RequireAuth>
          }
        />
        <Route
          path={CLIENT_ROUTES.DASHBORAD}
          element={
            <RequireAuth>
              <Layout /*dashboard={'dashboard'}*/>
                <Dashborad />
              </Layout>
            </RequireAuth>
          }
        />
        <Route
          path={CLIENT_ROUTES.ADMIN}
          element={
            <RequireAuth>
              <Layout>
                <AdminPage />
              </Layout>
            </RequireAuth>
          }
        />
        <Route
          path={CLIENT_ROUTES.MESSAGING}
          element={
            <RequireAuth>
              <Layout>
                <MessagingPage />
              </Layout>
            </RequireAuth>
          }
        />
        <Route
          path={CLIENT_ROUTES.ALLOCATIONS}
          element={
            <RequireAuth>
              <Layout>
                <AllocationsPage />
              </Layout>
            </RequireAuth>
          }
        />
        {/* <Route
          path={CLIENT_ROUTES.WORKSPACE}
          element={
            <RequireAuth>
              <Layout>
                <WorkspacePage />
              </Layout>
            </RequireAuth>
          }
        /> */}
        <Route
          path={CLIENT_ROUTES.VALIDATIONS}
          element={
            <RequireAuth>
              <Layout>
                <ValidationsPage />
              </Layout>
            </RequireAuth>
          }
        />
        <Route
          path={CLIENT_ROUTES.HISTORY}
          element={
            <RequireAuth>
              <Layout>
                <HistoryPage />
              </Layout>
            </RequireAuth>
          }
        />
        <Route
          path={CLIENT_ROUTES.NOT_FOUND}
          element={<Navigate replace to={initialRoute} />}
        />
      </Routes>
    </div>
  );
}

export default withAITracking(reactPlugin, App);
